<template>
  <div v-if="datacollection" class="vacancy-stat">
    <GoogleStatChart
      :chart-data="datacollection"
      :height="175"
    ></GoogleStatChart>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import GoogleStatChart from "./GoogleStatChart";

export default {
  components: {
    GoogleStatChart
  },
  props: {
    id: { type: [Number, String], required: true }
  },
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    googleAd: {
      query: gql`
        query GoogleAd($id: ID!, $datapointStart: Time!) {
          googleAd(id: $id) {
            id
            datapoints(from: $datapointStart) {
              date
              impressions
            }
          }
        }
      `,
      variables() {
        return {
          id: this.id,
          datapointStart: moment().subtract(7, "days")
        };
      }
    }
  },
  watch: {
    googleAd(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.date > b.date ? 1 : a.date < b.date ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let date = moment(data.date);
        if (labels.findIndex(val => val.diff(date) === 0) === -1) {
          labels.push(date);
        }
      }

      let impressionsData = [];
      for (let label of labels) {
        let impressions = 0;
        for (let data of stats.datapoints) {
          let time = moment(data.date);
          if (time.diff(label) === 0) {
            impressions = data.impressions;
          }
        }

        impressionsData.push(impressions);
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            label: "Impressionen",
            borderColor: "#48c6ef",
            data: impressionsData,
            fill: true,
            backgroundColor: "#48c6ef",
            pointHoverBackgroundColor: "#000000"
          }
        ]
      };
    }
  }
};
</script>
